module.exports = __webpack_public_path__ + "ff0919ae6b095a75bd0dfbbfbedebcc7.png";